var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "feedbackReceived flex row-between flex-wrap" },
    _vm._l(_vm.feedbackReceivedData, function (item, index) {
      return _c(
        "div",
        { key: index, staticClass: "bg-FF p-24 m-t-20 feedbackReceivedList" },
        [
          _c(
            "div",
            { staticClass: "m-b-24 feedbackReceivedListName" },
            [
              _c("img", {
                staticClass: "w-42 h-42 m-r-16",
                attrs: {
                  src: require("@/assets/icon/feedbackStatistics/user.png"),
                  alt: "人员",
                },
              }),
              _c("div", { staticClass: "userName font-32 text-left" }, [
                _vm._v(_vm._s(item.nickName)),
              ]),
              _c("van-icon", {
                staticClass: "m-r-0 cor-33",
                attrs: { name: "arrow", size: "18" },
                on: {
                  click: function ($event) {
                    return _vm.jumpDetail(item)
                  },
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "cor-99 font-28" }, [
            _c("div", { staticClass: "flex row-between m-b-16" }, [
              _vm._v("参与项目数："),
              _c("span", { staticClass: "cor-66" }, [
                _vm._v(_vm._s(item.projectNum) + "个"),
              ]),
            ]),
            _c("div", { staticClass: "flex row-between m-b-16" }, [
              _vm._v("参与任务："),
              _c("span", { staticClass: "cor-66" }, [
                _vm._v(_vm._s(item.taskNum) + "个"),
              ]),
            ]),
            _c("div", { staticClass: "flex row-between m-b-16" }, [
              _vm._v("反馈工时："),
              _c("span", { staticClass: "cor-66" }, [
                _vm._v(_vm._s(item.feedbackHourTotal) + "h"),
              ]),
            ]),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }